import { jsx as o, jsxs as v } from "react/jsx-runtime";
import { d as $, j as B, a6 as j } from "../../vendor-EQDp64ng.js";
import { createContext as R, forwardRef as u, useContext as I } from "react";
import { getSpacingClasses as k } from "../../utils/getSpacingClasses/index.js";
import { omitStyleRenderProps as c } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as f } from "../BaseIcon/index.js";
import { DotProgress as z } from "../DotProgress/index.js";
import { AriaBanner as O } from "./aria/Banner.js";
import '../../assets/index8.css';const S = "_banner_amh7w_1", V = "_sm_amh7w_15", p = "_md_amh7w_22", D = "_success_amh7w_30", E = "_info_amh7w_36", F = "_warning_amh7w_42", G = "_error_amh7w_48", L = "_global_amh7w_54", T = "_actionButton_amh7w_66", q = "_dismissButton_amh7w_67", H = "_body_amh7w_100", t = {
  banner: S,
  sm: V,
  md: p,
  success: D,
  info: E,
  warning: F,
  error: G,
  global: L,
  actionButton: T,
  dismissButton: q,
  body: H
}, J = {
  error: { color: "red", icon: "warning" },
  global: { icon: "info" },
  info: { color: "blue", icon: "lightbulb-info" },
  success: { color: "green", icon: "checkmark-circle" },
  warning: { color: "sienna", icon: "warning" }
}, h = R(null);
function K() {
  const e = I(h);
  if (!e)
    throw new Error("Banner.* components must be used within a <Banner> component.");
  return e;
}
const M = u(function({ children: n, size: s, m: i, mt: a, mr: r, mb: l, ml: b, isDismissible: w = !0, ...m }, g) {
  const d = m.variant ?? "info", x = d === "global" ? "md" : s ?? "md", y = $(
    t.banner,
    t[x],
    t[d],
    k({ m: i, mb: l, ml: b, mr: r, mt: a })
  ), { icon: C, color: _ } = J[d], A = m.isVisible !== void 0;
  return /* @__PURE__ */ o(
    O,
    {
      ref: g,
      ...c(m),
      className: y,
      "data-component": "Banner",
      children: ({ dismiss: N, dismissButtonProps: P }) => /* @__PURE__ */ v(
        h.Provider,
        {
          value: {
            dismiss: N,
            isControlled: A
          },
          children: [
            /* @__PURE__ */ o(f, { icon: C, color: _, mr: 3, ml: 3 }),
            n,
            w && /* @__PURE__ */ o(
              B,
              {
                ...c(P),
                className: t.dismissButton,
                slot: null,
                children: /* @__PURE__ */ o(f, { icon: "close", color: _ })
              }
            )
          ]
        }
      )
    }
  );
}), Q = u(function({ children: n }, s) {
  return /* @__PURE__ */ o("div", { ref: s, className: t.body, children: n });
}), U = u(
  function(n, s) {
    const { dismiss: i, isControlled: a } = K(), r = (l) => {
      n.onPress?.(l), a || i();
    };
    return typeof n.href == "string" ? /* @__PURE__ */ o(
      j,
      {
        ...c(n),
        className: t.actionButton,
        slot: null,
        onPress: r,
        ref: s,
        children: n.children
      }
    ) : /* @__PURE__ */ o(
      B,
      {
        ...c(n),
        className: t.actionButton,
        slot: null,
        onPress: r,
        ref: s,
        children: n.isPending ? /* @__PURE__ */ o(z, { "aria-label": n.isPendingAriaLabel }) : n.children
      }
    );
  }
), en = Object.assign(M, {
  Action: U,
  Body: Q
});
export {
  en as Banner
};
